// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__4rEGi","content":"Dashboard_content__7pyvG","charts":"Dashboard_charts__XiVDg"};